const rankings = [
  {
    rank: 1,
    medal: 'ri-vip-crown-fill',
    medalColor: 'text-accent-400',
    title: '某顶流深夜约会神秘女子，酒店同框照流出',
    hot: '爆',
    votes: '89.2万',
    trend: 'up',
    trendNum: '12',
  },
  {
    rank: 2,
    medal: 'ri-medal-fill',
    medalColor: 'text-foreground-400',
    title: '知名导演被曝片场耍大牌，剧组人员集体控诉',
    hot: '热',
    votes: '76.5万',
    trend: 'up',
    trendNum: '8',
  },
  {
    rank: 3,
    medal: 'ri-medal-fill',
    medalColor: 'text-amber-600',
    title: '选秀冠军疑似假唱翻车，现场音轨对比引爆热议',
    hot: '热',
    votes: '65.1万',
    trend: 'up',
    trendNum: '15',
  },
  {
    rank: 4,
    title: '网红情侣分手互撕，聊天记录曝光信息量巨大',
    votes: '52.8万',
    trend: 'new',
  },
  {
    rank: 5,
    title: '综艺节目黑幕被揭，选手淘汰顺序疑内定',
    votes: '41.3万',
    trend: 'down',
    trendNum: '3',
  },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-primary-500 tracking-wider uppercase mb-3 whitespace-nowrap">
            Trending
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            今日吃瓜热度榜
          </h2>
        </div>

        <div className="max-w-[800px] mx-auto bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankings.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 md:px-6 py-4 md:py-5 transition-colors duration-200 hover:bg-background-100/70 cursor-pointer ${
                i < rankings.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className="flex items-center gap-2 min-w-[48px]">
                {item.medal ? (
                  <span className={`w-8 h-8 flex items-center justify-center ${item.medalColor}`}>
                    <i className={`${item.medal} text-xl`}></i>
                  </span>
                ) : (
                  <span className="w-8 h-8 flex items-center justify-center text-sm font-bold text-foreground-500">
                    {item.rank}
                  </span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 line-clamp-1">
                  {item.title}
                </h3>
              </div>

              <div className="flex items-center gap-3 shrink-0">
                {item.hot && (
                  <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                    item.hot === '爆'
                      ? 'bg-primary-100 text-primary-600'
                      : 'bg-accent-100 text-accent-700'
                  }`}>
                    {item.hot}
                  </span>
                )}
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.votes} 票</span>
                <span className={`flex items-center gap-0.5 text-xs whitespace-nowrap ${
                  item.trend === 'up' ? 'text-primary-500' :
                  item.trend === 'down' ? 'text-foreground-400' :
                  'text-accent-500'
                }`}>
                  {item.trend === 'up' && <i className="ri-arrow-up-line"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line"></i>}
                  {item.trend === 'new' && <i className="ri-sparkling-line"></i>}
                  {item.trendNum && <span>{item.trendNum}</span>}
                  {item.trend === 'new' && <span>新</span>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}